import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import TableBase from "./TableBase.vue";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { CheckApprovalEarlyTime } from "@/models/approval/ApprovalResponse";
import EarlytimeExpandItem from "../expand/EarlytimeExpandItem.vue";

type Props = {
  shiftId: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'EarlytimeDialogTable',
  props: {
    shiftId: null
  },
  setup(__props: any) {

const props = __props as {
  shiftId: string;
};



const items = ref<CheckApprovalEarlyTime[]>([]);

const getItems = async () => {
  const response = await $get<CheckApprovalEarlyTime[]>(
    `${Paths.approval.shiftTable.earlytime}/${props.shiftId}`
  );
  if (response) {
    response.forEach(rec => (rec.dat.applicationBy = rec.applicationBy));
    items.value = response;
  }
};

watch(
  () => props.shiftId,
  async () => {
    await getItems();
  },
  { immediate: true }
);

return { __sfc: true,props, items, getItems, TableBase, EarlytimeExpandItem }
}

})